var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-pc-footer-new"},[_c('div',{staticClass:"g-footer-content-new"},[_vm._v(_vm._s(_vm.desc)+" ")]),_c('div',{staticClass:"g-footer-img-new"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }